import type {BioIconProps} from './common-types'

export function BrgIconAppLogoLetter({...attributes}: BioIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="32" fill="#363636" viewBox="0 0 27 32" {...attributes}>
      <path
        fill="#4F4F4F"
        fillRule="evenodd"
        d="M0 31.789V9.083C0 4.075 4.075 0 9.083 0H27v11.723a9.06 9.06 0 01-1.282 4.656A10.4 10.4 0 0127 21.387c0 2.778-1.082 5.39-3.047 7.355a10.334 10.334 0 01-7.356 3.047H0zm16.598-2.833c4.174 0 7.57-3.395 7.57-7.57 0-.917-.16-1.807-.477-2.651a9.038 9.038 0 01-5.774 2.07H2.832v8.151h13.766zm1.32-10.983c1.61 0 3.112-.597 4.273-1.688a7.542 7.542 0 00-5.593-2.469H2.832v4.158h15.085zm-1.32-6.99c1.488 0 2.924.308 4.27.915a10.34 10.34 0 012.922 1.972 6.199 6.199 0 00.378-2.147v-8.89H9.083a6.258 6.258 0 00-6.25 6.25v1.9h13.765z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}
